import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClientsListScreenComponent} from './screen/clients-list-screen.component';
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/clients-list.reducer";
import {EffectsModule} from "@ngrx/effects";
import {ClientsListEffects} from "./core/clients-list.effects";
import {SharedModule} from "../../shared/shared.module";
import {MatExpansionModule} from "@angular/material/expansion";
import {
  ClinicInformationTableComponent
} from './components/tables/clinic-information-table/clinic-information-table.component';
import {
  GroupInformationTableComponent
} from './components/tables/group-information-table/group-information-table.component';
import {
  ParticipantOrCaregiverInformationTableComponent
} from './components/tables/participant-or-caregiver-information-table/participant-or-caregiver-information-table.component';
import {
  ParticipantWeightInformationTableComponent
} from './components/tables/participant-weight-information-table/participant-weight-information-table.component';
import {
  ParticipantBehaviourInformationTableComponent
} from './components/tables/participant-behaviour-information-table/participant-behaviour-information-table.component';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatTooltipModule} from '@angular/material/tooltip';
import {
  MeasurementInformationTableComponent
} from './components/tables/measurement-information-table/measurement-information-table.component';
import {
  ClinicInformationFilterComponent
} from './components/filters/clinic-information-filter/clinic-information-filter.component';
import {
  GroupInformationFilterComponent
} from './components/filters/group-information-filter/group-information-filter.component';
import {
  MeasurementInformationFilterComponent
} from './components/filters/measurment-information-filter/measurement-information-filter.component';
import {
  ParticipantBehaviourInformationFilterComponent
} from './components/filters/participant-beahaviour-information-filter/participant-behaviour-information-filter.component';
import {
  ParticipantOrCaregiverInformationFilterComponent
} from './components/filters/participant-or-caregiver-information-filter/participant-or-caregiver-information-filter.component';
import {
  ParticipantWeightInformationFilterComponent
} from './components/filters/participant-weight-information-filter/participant-weight-information-filter.component';
import {AddMetricOptionComponent} from './components/add-metric-option/add-metric-option.component';
import {EditMetricOptionComponent} from './components/edit-metric-option/edit-metric-option.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';


@NgModule({
  declarations: [
    ClientsListScreenComponent,
    ClinicInformationTableComponent,
    GroupInformationTableComponent,
    ParticipantOrCaregiverInformationTableComponent,
    ParticipantWeightInformationTableComponent,
    ParticipantBehaviourInformationTableComponent,
    MeasurementInformationTableComponent,
    ClinicInformationFilterComponent,
    GroupInformationFilterComponent,
    MeasurementInformationFilterComponent,
    ParticipantBehaviourInformationFilterComponent,
    ParticipantOrCaregiverInformationFilterComponent,
    ParticipantWeightInformationFilterComponent,
    AddMetricOptionComponent,
    EditMetricOptionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('ss-cord.clients-list', reducer),
    EffectsModule.forFeature(
      [ClientsListEffects]
    ),
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    InfiniteScrollModule,
  ]
})
export class ClientsListModule {
}
